import { LoginModalPage } from './../../pages/login-modal/login-modal.page';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonRouterOutlet, ModalController, NavController, isPlatform } from '@ionic/angular';
import { NavigationEnd, Router } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  title: string;
  isSubPage: boolean;
  dropdown = false;
  private menuItems = this.navigationService.getNavItems();

  @ViewChild('productbtn', { read: ElementRef }) productbtn: ElementRef;
  @ViewChild('dropdownbox', { read: ElementRef }) dropdownbox: ElementRef;

  constructor(private modalController: ModalController, private routerOutlet: IonRouterOutlet,
    private navCtrl: NavController, private router: Router, private navigationService: NavigationService) { }

  ngOnInit() {
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
       const navItem = this.menuItems.filter(item => item.path.indexOf(ev.url) >= 0);
       if (navItem.length > 0) {
        this.title = navItem[0].title;
       }
       this.isSubPage = ev.url.split('/').length > 2;
      }
    });
  }

  hideDropdown(event) {
    const xTouch = (event.clientX).toFixed(2);
    const yTouch = (event.clientY).toFixed(2);

    const rect = this.productbtn.nativeElement.getBoundingClientRect();
    const topBoundary = (rect.top + 2).toFixed(2);
    const leftBoundary = (rect.left + 2).toFixed(2);
    const rightBoundary = (rect.right - 2).toFixed(2);

    if (xTouch < leftBoundary || xTouch > rightBoundary || yTouch < topBoundary) {
      this.dropdown = false;
    }
  }

  async openLogin() {
    const modal = await this.modalController.create({
      component: LoginModalPage,
      presentingElement: this.routerOutlet.nativeEl,
      swipeToClose: true,
      cssClass: isPlatform('desktop') ? 'login-modal' : ''
    });

    await modal.present();
  }

  goBack() {
    this.navCtrl.back();
  }
}
